import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule, IonicPageModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

// Plugins
import { Camera } from '@ionic-native/camera';
import { ImagePicker } from '@ionic-native/image-picker';
import { SocialSharing } from '@ionic-native/social-sharing';
import { AbsoluteDrag } from '../directives/absolute-drag/absolute-drag'

import { MyApp } from './app.component';


import { HttpModule } from '@angular/http'
import { IonicStorageModule } from '@ionic/storage';
import { PaisesPage } from '../pages/paises/paises'
import { PaisesEditarPage } from '../pages/paises-editar/paises-editar'
import { PaisesProvider } from '../providers/paises/paises';

import { CompaniasPage } from '../pages/companias/companias'
import { CompaniasEditarPage } from '../pages/companias/companias-editar/companias-editar'
import { CompaniasProvider } from '../providers/companias/companias'

import { UsuariosPage } from '../pages/usuarios/usuarios'
import { UsuariosProvider } from '../providers/usuarios/usuarios'

import { CargosPage } from '../pages/cargos/cargos'
import { CargosEditarPage } from '../pages/cargos/cargos-editar/cargos-editar'
import { CargosProvider } from '../providers/cargos/cargos'

import { MesasPage } from '../pages/mesas/mesas';

import { TurnosPage } from '../pages/turnos/turnos'
import { TurnosEditarPage } from '../pages/turnos/turnos-editar/turnos-editar'
import { TurnosProvider } from '../providers/turnos/turnos'

import { ProductosPage } from '../pages/productos/productos'
import { ProductosProvider } from '../providers/productos/productos'

import { CajaPage } from '../pages/caja/caja'
import { CajaProvider } from '../providers/caja/caja'

import { GruposProductosPage } from '../pages/gruposProductos/gruposProductos'
import { GruposProductosProvider } from '../providers/gruposProductos/gruposProductos'

import { ProductosPorGruposPage } from '../pages/productos-por-grupos/productos-por-grupos'
import { ProductosPorGruposProvider } from '../providers/productos-por-grupos/productos-por-grupos'

import { PipesModule } from '../pipes/pipes.module';

import { TagInputModule } from 'ng2-tag-input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!

import { ClientesPage } from '../pages/clientes/clientes'
import { ClientesEditarPage }  from '../pages/clientes-editar/clientes-editar'

import { ClientesProvider } from '../providers/clientes/clientes';

import { ClientesCorreosElectronicosPage } from '../pages/clientes-correos-electronicos/clientes-correos-electronicos'
import { ClientesCorreosElectronicosEditarPage } from '../pages/clientes-correos-electronicos-editar/clientes-correos-electronicos-editar'

import { ClientesCorreosProvider } from '../providers/clientes-correos/clientes-correos';

import { ClientesTelefonosProvider } from '../providers/clientes-telefonos/clientes-telefonos';

import { ClientesTelefonosEditarPage } from '../pages/clientes-telefonos-editar/clientes-telefonos-editar'
import { DepartamentosProvider } from '../providers/departamentos/departamentos';

import { DepartamentosPage } from '../pages/departamentos/departamentos'
import { DepartamentosEditarPage } from '../pages/departamentos-editar/departamentos-editar'

import { UsuariosEditarPage } from '../pages/usuarios/usuarios-editar/usuarios-editar'

import { ProductosElaboradosPage } from '../pages/productos-elaborados/productos-elaborados'
import { ProductosElaboradosProvider } from '../providers/productos-elaborados/productos-elaborados';

import { ProductosElaboradosContenidoPage } from '../pages/productos-elaborados-contenido/productos-elaborados-contenido'
import { ProductosElaboradosContenidoDetallePage } from '../pages/productos-elaborados-contenido-detalle/productos-elaborados-contenido-detalle'
import { ProductosElaboradosContenidoProvider } from '../providers/productos-elaborados-contenido/productos-elaborados-contenido';

import { ProveedoresCargarStockPage } from '../pages/proveedores-cargar-stock/proveedores-cargar-stock'
import { ProveedoresProvider } from '../providers/proveedores/proveedores';
import { ProveedoresCargarStockProvider } from '../providers/proveedores-cargar-stock/proveedores-cargar-stock';

import { GridProveedoresPage } from '../pages/grid-proveedores/grid-proveedores'
import { SeguimientoIngresosStockProvider } from '../providers/seguimiento-ingresos-stock/seguimiento-ingresos-stock';

import { DenominacionesPage } from '../pages/denominaciones/denominaciones'
import { GridDenominacionesPage } from '../pages/grid-denominaciones/grid-denominaciones'
import { DenominacionesProvider } from '../providers/denominaciones/denominaciones';
import { CuadreCajaDiarioValoresPorDenominacionPage } from '../pages/cuadre-caja-diario-valores-por-denominacion/cuadre-caja-diario-valores-por-denominacion'
import { CuadreCajaDiarioValoresPorDenominacionProvider } from '../providers/cuadre-caja-diario-valores-por-denominacion/cuadre-caja-diario-valores-por-denominacion';

import { ProveedoresPage } from '../pages/proveedores/proveedores'
import { ImpresoraPage } from '../pages/impresora/impresora'
import { MesasProvider } from '../providers/mesas/mesas';
import { PermisosProvider } from '../providers/permisos/permisos';
import { PermisosPage } from '../pages/permisos/permisos'
import { PermisosEditarPage } from '../pages/permisos-editar/permisos-editar'
import { MeseroProvider } from '../providers/mesero/mesero';

import { GraficasProvider } from '../providers/graficas/graficas';
import { CentroDeCostosProvider } from '../providers/centro-de-costos/centro-de-costos';
import { ComandasPage } from '../pages/comandas/comandas'
import { DesperdiciosPage } from '../pages/desperdicios/desperdicios'
import { DesperdiciosProvider } from '../providers/desperdicios/desperdicios';
import { ComandasProvider } from '../providers/comandas/comandas';

import { ImagenesPage } from '../pages/imagenes/imagenes'
import { SelectSearchableModule } from 'ionic-select-searchable';
import { NgxPaginationModule } from 'ngx-pagination'

import { CompaniasUsuariosPage } from '../pages/companias-usuarios/companias-usuarios'
import { CompaniasUsuariosProvider } from '../providers/companias-usuarios/companias-usuarios';
import { PermisosOpcionesUsuariosProvider } from '../providers/permisos-opciones-usuarios/permisos-opciones-usuarios';
import { UtilsProvider } from '../providers/utils/utils';


import { ElectronService } from 'ngx-electron';
import { DomiciliosPage } from '../pages/domicilios/domicilios'
import { MeseromeseroPage } from '../pages/meseromesero/meseromesero'
import { CuentasPorCobrarPage } from '../pages/cuentas-por-cobrar/cuentas-por-cobrar'
import { CuentasPorCobrarProvider } from '../providers/cuentas-por-cobrar/cuentas-por-cobrar';
import { ReportesPage } from '../pages/reportes/reportes'
import { VentasDiariasPorCostosPage } from '../pages/ventas-diarias-por-costos/ventas-diarias-por-costos'
import { SeguridadPage } from '../pages/seguridad/seguridad'
import { CorreoPage } from '../pages/correo/correo'
import { ParametrosGeneralesPage } from '../pages/parametros-generales/parametros-generales'
import { ContenedorPage } from '../pages/contenedor/contenedor'
import {  ContenedorEditarPage } from '../pages/contenedor-editar/contenedor-editar'
import { UbicacionPage } from '../pages/ubicacion/ubicacion'
import {ProductosContenedorPage} from '../pages/productos-contenedor/productos-contenedor'
import { ImprimirPage } from '../pages/imprimir/imprimir'
import { VersionamientoPage } from '../pages/versionamiento/versionamiento'
import { VersionamientoProvider } from '../providers/versionamiento/versionamiento';
import { ProductosPorGruposDragPage } from '../pages/productos-por-grupos-drag/productos-por-grupos-drag'
import { PushPage } from '../pages/push/push'
import { PushProvider } from '../providers/push/push';
import { ProductosEditarPage } from '../pages/productos-editar/productos-editar'
import { InformesProvider } from '../providers/informes/informes'
import { InformeBalanceNegocioPage } from '../pages/informe-balance-negocio/informe-balance-negocio'
import { InformeReimprimirReciboCajaPage } from '../pages/informe-reimprimir-recibo-caja/informe-reimprimir-recibo-caja'
import { InformeCantidadesDescontadasInventarioPorDiaPage } from '../pages/informe-cantidades-descontadas-inventario-por-dia/informe-cantidades-descontadas-inventario-por-dia'
import { InformeProductosVendidosPorDiasPage } from '../pages/informe-productos-vendidos-por-dias/informe-productos-vendidos-por-dias'
import { InformeDesperdiciosPorDiaPage } from '../pages/informe-desperdicios-por-dia/informe-desperdicios-por-dia'
import { InformeCuadresDiariosPage } from '../pages/informe-cuadres-diarios/informe-cuadres-diarios'
import { InformeExistenciasProductosActualesPage } from '../pages/informe-existencias-productos-actuales/informe-existencias-productos-actuales'
import { InformeIngresoMercanciaPorDiaPage } from '../pages/informe-ingreso-mercancia-por-dia/informe-ingreso-mercancia-por-dia'
import { ImpresoraBluetoothPage } from '../pages/impresora-bluetooth/impresora-bluetooth'
import { ImpresoraBluePage } from '../pages/impresora-blue/impresora-blue'
import { InformeVentasDevueltasPage } from '../pages/informe-ventas-devueltas/informe-ventas-devueltas'
import { PermisosOpcionesUsuariosPage } from '../pages/permisos-opciones-usuarios/permisos-opciones-usuarios'
import { ClienteSelectPage } from '../pages/cliente-select/cliente-select';
import { PRODUCCION } from '../config/url.servicio';

//ngrx
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { appReducers } from './app.reducer';
import { ParametrosCajaPage } from '../pages/parametros-caja/parametros-caja'
import { ConceptosEgresosPage } from '../pages/conceptos-egresos/conceptos-egresos'
import { ConceptosEgresosProvider } from '../providers/conceptos-egresos/conceptos-egresos'
import { InformeCuentasPorCobrarPage } from '../pages/informe-cuentas-por-cobrar/informe-cuentas-por-cobrar'
import { DianFacturaElectronicaPage } from '../pages/dian-factura-electronica/dian-factura-electronica'
import { PedidosSalonPage } from '../pages/pedidos-salon/pedidos-salon';
import { GestionarPedidoPage } from '../pages/gestionar-pedido/gestionar-pedido';
import { UsuarioSelectPage } from '../pages/usuario-select/usuario-select';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';
import { ClienteRapidoPage } from '../pages/cliente-rapido/cliente-rapido';
import { WhatsappPage } from '../pages/whatsapp/whatsapp';
import { EntidadesGeneralesPage } from '../pages/entidades-generales/entidades-generales';
import { EntidadesEditarPage } from '../pages/entidades-editar/entidades-editar';
import { SubirRegistrosPage } from '../pages/subir-registros/subir-registros';
import { DevolverVentasPage } from '../pages/devolver-ventas/devolver-ventas';
import { DevolverAbonosPage } from '../pages/devolver-abonos/devolver-abonos';
import { ReeemprimircomandaspedidossalonPage } from '../pages/reeemprimircomandaspedidossalon/reeemprimircomandaspedidossalon';
import { GestionporproductoPage } from '../pages/gestionporproducto/gestionporproducto';
import { GestionCambioPrecioPorProductoPage } from '../pages/gestion-cambio-precio-por-producto/gestion-cambio-precio-por-producto';
import { SimuladorCuentasPorCobrarPage } from '../pages/simulador-cuentas-por-cobrar/simulador-cuentas-por-cobrar';
import { CarruselImagePage } from '../pages/carrusel-image/carrusel-image';
import { CrearCarruselImagePage } from '../pages/crear-carrusel-image/crear-carrusel-image';
import { SalonPage } from '../pages/salon/salon';
import { EgresosIngresosDiariosPage } from '../pages/egresos-ingresos-diarios/egresos-ingresos-diarios';
import { InformeGestionesPage } from '../pages/informe-gestiones/informe-gestiones';
import { ReservasPage } from '../pages/reservas/reservas';
import { CalendarComponent } from '../components/calendar/calendar';
import { GestionclienteComponent } from '../components/gestioncliente/gestioncliente';
import { GestionproductosComponent } from '../components/gestionproductos/gestionproductos';
import { GestiongruposreservasComponent } from '../components/gestiongruposreservas/gestiongruposreservas';
import { PoselectronicoPage } from '../pages/poselectronico/poselectronico';
import { calendarDatosCompartidosService } from '../components/calendar/calendarDatosCompartidosService';
import { MenuPage } from '../pages/menu/menu';
import { GruposReservasPage } from '../pages/grupos-reservas/grupos-reservas';
import { TiposReservasPage } from '../pages/tipos-reservas/tipos-reservas';
import { GruposReservasPorProductoPage } from '../pages/grupos-reservas-por-producto/grupos-reservas-por-producto';
import { TenderoComponent } from '../components/tendero/tendero';
import { ClientesVentasComponent } from '../components/clientes-ventas/clientes-ventas';
import { ReservasValorLiquidarComponent } from '../components/reservas-valor-liquidar/reservas-valor-liquidar';
import { ReservasTiposPorValorPage } from '../pages/reservas-tipos-por-valor/reservas-tipos-por-valor';
import { ReservasSinAsignarPage } from '../pages/reservas-sin-asignar/reservas-sin-asignar';
import { InformeCambiosMaestroComponent } from '../components/informe-cambios-maestro/informe-cambios-maestro';
import { PosElectronicoComponent } from '../components/pos-electronico/pos-electronico';
import { ProveedoraPorProductoComponent } from '../components/proveedora-por-producto/proveedora-por-producto';
import { ProveedoraPorProductoEquivalenciaComponent } from '../components/proveedora-por-producto-equivalencia/proveedora-por-producto-equivalencia';
import { ProveedoraActualizarProductoComponent } from '../components/proveedora-actualizar-producto/proveedora-actualizar-producto';
import { FacturaSelectComponent } from '../components/factura-select/factura-select';
import { EstadosParqueaderoComponent } from '../components/estados-parqueadero/estados-parqueadero';
import { EstadosParqueaderosPorValorComponent } from '../components/estados-parqueaderos-por-valor/estados-parqueaderos-por-valor';
import { ParqueaderosComponent } from '../components/parqueaderos/parqueaderos';
import { ReservasGrupalesComponent } from '../components/reservas-grupales/reservas-grupales';
import { ProductosRapidosComponent } from '../components/productos-rapidos/productos-rapidos';
import { MovimientosElectronicosComponent } from '../components/movimientos-electronicos/movimientos-electronicos';
import { InformesMovimientosElectronicosComponent } from '../components/informes-movimientos-electronicos/informes-movimientos-electronicos';
import { FormaPagoPopoverComponent } from '../pages/forma-pago-popover/forma-pago-popover';
import { ImprimirGlobalComponent } from '../pages/imprimir-global/imprimir-global';
import { InteresesCreditosComponent } from '../pages/intereses-creditos/intereses-creditos';
import { CreditosComponent } from '../components/creditos/creditos';
import { CostosadicionalesPage } from '../pages/costosadicionales/costosadicionales';
import { InteresesCreditosPorCostosAdicionalesComponent } from '../pages/intereses-creditos-por-costos-adicionales/intereses-creditosporcostosadicionales';
import { GestionarInteresesCreditosPorCostosAdicionalesComponent } from '../pages/gestionar-interes-creditos-por-costos-adicionales/gestionar-interes-creditos-por-costos-adicionales';
import { CuentasPorCobrarCreditosPage } from '../pages/cuentas-por-cobrar-creditos/cuentas-por-cobrar-creditos';
import { CuentasPorCobrarCreditosVisualizarPage } from '../pages/cuentas-por-cobrar-creditos-visualizar/cuentas-por-cobrar-creditos-visualizar';
import { ProductosCamposAdicionalesComponent } from '../components/productos-campos-adicionales/productos-campos-adicionales';
import { ProductosCamposAdicionalesCambiarValorComponent } from '../components/productos-campos-adicionales-cambiar-valor/productos-campos-adicionales-cambiar-valor';
import { CuadreCajaDiarioDomiciliosPage } from '../pages/cuadre-caja-diario-domicilios/cuadre-caja-diario-domicilios';
import { CuentasPorCobrarCreditosVisualizarPlanDePagosPage } from '../pages/cuentas-por-cobrar-creditos-visualizar-plan-de-pagos/cuentas-por-cobrar-creditos-visualizar-plan-de-pagos';
import { ProductosTransladosComponent } from '../components/productos-translados/productos-translados';
import { ParametrosCreditosPage } from '../pages/parametros-creditos/parametros-creditos';
import { CallcenterPage } from '../pages/callcenter/callcenter';
import { CajaverticalPage } from '../pages/cajavertical/cajavertical';
import { PersonalizarPage } from '../pages/personalizar/personalizar'
import { FormasDePagoPage } from '../pages/formasdepago/formasdepago';
import { ProductosCamposAdicionalesCambiarValorImpuestosComponent } from '../components/productos-campos-adicionales-cambiar-valor-impuestos/productos-campos-adicionales-cambiar-valor-impuestos';
import { ShortcutConfiguratorComponent } from '../components/shortcutconfigurator/shortcut-configurator';
import { UsuarioPedidoSalonComponent } from '../components/usuariopedidosalon/usuariopedidosalon';
import { TecladoComponent } from '../components/teclado/teclado';
import { ProductorapidocajaverticalComponent } from '../components/productorapidocajavertical/productorapidocajavertical';
import { ModalSeleccionComponent } from '../components/modalseleccion/modalseleccion';
import { inventarioPage } from '../pages/inventario/inventario';
import { IaComponent } from '../components/ia/ia';

@NgModule({
  declarations: [
    MyApp,
    PaisesPage,
    PaisesEditarPage,

    CompaniasPage,
    CompaniasEditarPage,

    UsuariosPage,
    UsuariosEditarPage,

    CargosPage,
    CargosEditarPage,

    AbsoluteDrag,
    MesasPage,

    TurnosPage,
    TurnosEditarPage,

    ProductosPage,

    CajaPage,

    GruposProductosPage,

    ProductosPorGruposPage,

    ClientesPage,
    ClientesEditarPage,

    ClientesCorreosElectronicosPage,
    ClientesCorreosElectronicosEditarPage,

    ClientesTelefonosEditarPage,

    DepartamentosPage,
    DepartamentosEditarPage,

    ProductosElaboradosPage,

    ProductosElaboradosContenidoPage,
    ProductosElaboradosContenidoDetallePage,

    ProveedoresCargarStockPage,

    GridProveedoresPage,

    DenominacionesPage,
    CuadreCajaDiarioValoresPorDenominacionPage,
    GridDenominacionesPage,

    ProveedoresPage,

    ImpresoraPage,

    PermisosPage,
    PermisosEditarPage,


    ComandasPage,

    DesperdiciosPage,

    ImagenesPage,

    CompaniasUsuariosPage,
    DomiciliosPage,
    MeseromeseroPage,
    CuentasPorCobrarPage,
    ReportesPage,
    VentasDiariasPorCostosPage,
    SeguridadPage,
    CorreoPage,
    ParametrosGeneralesPage,
    ContenedorPage,
    ContenedorEditarPage,
    UbicacionPage,
    ProductosContenedorPage,
    ImprimirPage,
    VersionamientoPage,
    ProductosPorGruposDragPage,
    PushPage,
    ProductosEditarPage,
    InformeBalanceNegocioPage,
    InformeReimprimirReciboCajaPage,
    InformeCantidadesDescontadasInventarioPorDiaPage,
    InformeProductosVendidosPorDiasPage,
    InformeDesperdiciosPorDiaPage,
    InformeCuadresDiariosPage,
    InformeExistenciasProductosActualesPage,
    InformeIngresoMercanciaPorDiaPage,
    ImpresoraBluetoothPage,
    ImpresoraBluePage,
    InformeVentasDevueltasPage,
    ParametrosCajaPage,
    PermisosOpcionesUsuariosPage,
    ConceptosEgresosPage,
    InformeCuentasPorCobrarPage,
    ClienteSelectPage,
    DianFacturaElectronicaPage,
    PedidosSalonPage,
    GestionarPedidoPage,
    UsuarioSelectPage,
    ClienteRapidoPage,
    WhatsappPage,
    EntidadesGeneralesPage,
    EntidadesEditarPage,
    SubirRegistrosPage,
    DevolverVentasPage,
    DevolverAbonosPage,
    ReeemprimircomandaspedidossalonPage,
    GestionporproductoPage,
    GestionCambioPrecioPorProductoPage,
    SimuladorCuentasPorCobrarPage,
    CarruselImagePage,
    CrearCarruselImagePage,
    SalonPage,
    EgresosIngresosDiariosPage,
    InformeGestionesPage,
    ReservasPage,
    CalendarComponent,
    GestionclienteComponent,
    GestionproductosComponent,
    GestiongruposreservasComponent,
    PoselectronicoPage,
    MenuPage,
    GruposReservasPage,
    TiposReservasPage,
    GruposReservasPorProductoPage,
    TenderoComponent,
    ClientesVentasComponent,
    ReservasValorLiquidarComponent,
    ReservasTiposPorValorPage,
    ReservasSinAsignarPage,
    ReservasSinAsignarPage,
    InformeCambiosMaestroComponent,
    PosElectronicoComponent,
    ProveedoraPorProductoComponent,
    ProveedoraPorProductoEquivalenciaComponent,
    ProveedoraActualizarProductoComponent,
    FacturaSelectComponent,
    EstadosParqueaderoComponent,
    EstadosParqueaderosPorValorComponent,
    ParqueaderosComponent,
    ReservasGrupalesComponent,
    ProductosRapidosComponent,
    MovimientosElectronicosComponent,
    InformesMovimientosElectronicosComponent,
    FormaPagoPopoverComponent,
    ImprimirGlobalComponent,
    InteresesCreditosComponent,
    CreditosComponent,
    CostosadicionalesPage,
    InteresesCreditosPorCostosAdicionalesComponent,
    GestionarInteresesCreditosPorCostosAdicionalesComponent,
    CuentasPorCobrarCreditosPage,
    CuentasPorCobrarCreditosVisualizarPage,
    ProductosCamposAdicionalesComponent,
    ProductosCamposAdicionalesCambiarValorComponent,
    CuadreCajaDiarioDomiciliosPage,
    CuentasPorCobrarCreditosVisualizarPlanDePagosPage,
    ProductosTransladosComponent,
    ParametrosCreditosPage,
    CallcenterPage,
    CajaverticalPage,
    PersonalizarPage,
    FormasDePagoPage,
    ProductosCamposAdicionalesCambiarValorImpuestosComponent,
    ShortcutConfiguratorComponent,
    UsuarioPedidoSalonComponent,
    TecladoComponent,
    ProductorapidocajaverticalComponent,
    ModalSeleccionComponent,
    inventarioPage,
    IaComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    PipesModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    TagInputModule,
    BrowserAnimationsModule,
    SelectSearchableModule,
    NgxPaginationModule,
    StoreModule.forRoot( appReducers ),
    // EffectsModule.forRoot( effectsArr ),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: PRODUCCION // Restrict extension to log-only mode
    }),
    IonicPageModule.forChild(FormaPagoPopoverComponent),
    IonicPageModule.forChild(ImprimirGlobalComponent)

  ],
  bootstrap: [ IonicApp ],
  entryComponents: [
    MyApp,
    PaisesPage,
    PaisesEditarPage,

    CompaniasPage,
    CompaniasEditarPage,

    UsuariosPage,
    UsuariosEditarPage,

    CargosPage,
    CargosEditarPage,
    MesasPage,

    TurnosPage,
    TurnosEditarPage,

    ProductosPage,

    CajaPage,

    GruposProductosPage,

    ProductosPorGruposPage,

    ClientesPage,
    ClientesEditarPage,

    ClientesCorreosElectronicosPage,
    ClientesCorreosElectronicosEditarPage,

    ClientesTelefonosEditarPage,

    DepartamentosPage,
    DepartamentosEditarPage,

    ProductosElaboradosPage,

    ProductosElaboradosContenidoPage,
    ProductosElaboradosContenidoDetallePage,

    ProveedoresCargarStockPage,

    GridProveedoresPage,

    DenominacionesPage,
    CuadreCajaDiarioValoresPorDenominacionPage,
    GridDenominacionesPage,

    ProveedoresPage,

    ImpresoraPage,

    PermisosPage,
    PermisosEditarPage,

    ComandasPage,

    DesperdiciosPage,

    ImagenesPage,

    CompaniasUsuariosPage,
    DomiciliosPage,
    MeseromeseroPage,
    CuentasPorCobrarPage,
    ReportesPage,
    VentasDiariasPorCostosPage,
    SeguridadPage,
    CorreoPage,
    ParametrosGeneralesPage,
    ContenedorPage,
    ContenedorEditarPage,
    UbicacionPage,
    ProductosContenedorPage,
    ImprimirPage,
    VersionamientoPage,
    ProductosPorGruposDragPage,
    PushPage,
    ProductosEditarPage,
    InformeBalanceNegocioPage,
    InformeReimprimirReciboCajaPage,
    InformeCantidadesDescontadasInventarioPorDiaPage,
    InformeProductosVendidosPorDiasPage,
    InformeDesperdiciosPorDiaPage,
    InformeCuadresDiariosPage,
    InformeExistenciasProductosActualesPage,
    InformeIngresoMercanciaPorDiaPage,
    ImpresoraBluetoothPage,
    ImpresoraBluePage,
    InformeVentasDevueltasPage,
    ParametrosCajaPage,
    PermisosOpcionesUsuariosPage,
    ConceptosEgresosPage,
    InformeCuentasPorCobrarPage,
    ClienteSelectPage,
    DianFacturaElectronicaPage,
    PedidosSalonPage,
    GestionarPedidoPage,
    UsuarioSelectPage,
    ClienteRapidoPage,
    WhatsappPage,
    EntidadesGeneralesPage,
    EntidadesEditarPage,
    SubirRegistrosPage,
    DevolverVentasPage,
    DevolverAbonosPage,
    ReeemprimircomandaspedidossalonPage,
    GestionporproductoPage,
    GestionCambioPrecioPorProductoPage,
    SimuladorCuentasPorCobrarPage,
    CarruselImagePage,
    CrearCarruselImagePage,
    SalonPage,
    EgresosIngresosDiariosPage,
    InformeGestionesPage,
    ReservasPage,
    CalendarComponent,
    GestionclienteComponent,
    GestionproductosComponent,
    GestiongruposreservasComponent,
    PoselectronicoPage,
    MenuPage,
    GruposReservasPage,
    TiposReservasPage,
    GruposReservasPorProductoPage,
    TenderoComponent,
    ClientesVentasComponent,
    ReservasValorLiquidarComponent,
    ReservasTiposPorValorPage,
    ReservasSinAsignarPage,
    InformeCambiosMaestroComponent,
    PosElectronicoComponent,
    ProveedoraPorProductoComponent,
    ProveedoraPorProductoEquivalenciaComponent,
    ProveedoraActualizarProductoComponent,
    FacturaSelectComponent,
    EstadosParqueaderoComponent,
    EstadosParqueaderosPorValorComponent,
    ParqueaderosComponent,
    ReservasGrupalesComponent,
    ProductosRapidosComponent,
    MovimientosElectronicosComponent,
    InformesMovimientosElectronicosComponent,
    FormaPagoPopoverComponent,
    ImprimirGlobalComponent,
    InteresesCreditosComponent,
    CreditosComponent,
    CostosadicionalesPage,
    InteresesCreditosPorCostosAdicionalesComponent,
    GestionarInteresesCreditosPorCostosAdicionalesComponent,
    CuentasPorCobrarCreditosPage,
    CuentasPorCobrarCreditosVisualizarPage,
    ProductosCamposAdicionalesComponent,
    ProductosCamposAdicionalesCambiarValorComponent,
    CuadreCajaDiarioDomiciliosPage,
    CuentasPorCobrarCreditosVisualizarPlanDePagosPage,
    ProductosTransladosComponent,
    ParametrosCreditosPage,
    CallcenterPage,
    CajaverticalPage,
    PersonalizarPage,
    FormasDePagoPage,
    ProductosCamposAdicionalesCambiarValorImpuestosComponent,
    ShortcutConfiguratorComponent,
    UsuarioPedidoSalonComponent,
    TecladoComponent,
    ProductorapidocajaverticalComponent,
    ModalSeleccionComponent,
    inventarioPage,
    IaComponent
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Camera,
    ImagePicker,
    SocialSharing,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    PaisesProvider,
    CompaniasProvider,
    UsuariosProvider,
    CargosProvider,
    TurnosProvider,
    ProductosProvider,
    GruposProductosProvider,
    ProductosPorGruposProvider,
    CajaProvider,
    ClientesProvider,
    ClientesCorreosProvider,
    ClientesTelefonosProvider,
    DepartamentosProvider,
    ProductosElaboradosProvider,
    ProductosElaboradosContenidoProvider,
    ProveedoresProvider,
    ProveedoresCargarStockProvider,
    SeguimientoIngresosStockProvider,
    DenominacionesProvider,
    CuadreCajaDiarioValoresPorDenominacionProvider,
    ProveedoresProvider,
    MesasProvider,
    PermisosProvider,
    MeseroProvider,
    GraficasProvider,
    CentroDeCostosProvider,
    DesperdiciosProvider,
    ComandasProvider,
    CompaniasUsuariosProvider,
    UtilsProvider,
    ElectronService,
    CuentasPorCobrarProvider,
    VersionamientoProvider,
    PushProvider,
    InformesProvider,
    PermisosOpcionesUsuariosProvider,
    ConceptosEgresosProvider,
    BluetoothSerial,
    calendarDatosCompartidosService,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts